moduleViewApp.controller('setSeriesCtrl', ['$scope', 'DebugHelper', '$routeParams', 'moduleContextService', 'SetsResource', ($scope, DebugHelper, $routeParams, moduleContextService, SetsResource) ->
  DebugHelper.register("setSeriesCtrl", $scope)

  _.assignIn $scope,
    seriesLoaded: false
    series: []
    paddingWidth = 40
    moduleContextService: moduleContextService

    fetchSeries: ->
      SetsResource.series { id: $routeParams.set_id }
      , (success) ->
        $scope.series = success.response
        for series in $scope.series
          if !series.settings
            series.settings = {}
        $scope.seriesLoaded = true
        
    tileOffset: ->
      paddingWidth = 40
      $("#site-navigation").width() + paddingWidth || paddingWidth
          
  $scope.fetchSeries()
])
